export const meta: BlockMeta = {
  title: "Accordion List",
  description: "An expandable accordion list",
  keywords: ["downloads", "files", "content"],
  cache: false,
  tags: ["root"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame", "resource"],
  },
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { createContext, useState } from "react"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "flex flex-col",
  variants: {
    admin: {
      false: "my-3",
    },
  },
  defaultVariants: {
    admin: false,
  },
})

export const AccordionListContext = createContext<{ activeItem?: string; setActiveItem: (index?: string) => void }>({
  activeItem: undefined,
  setActiveItem: () => {},
})

export default defineBlock("content/accordion-list", (props) => {
  const [activeItem, setActiveItem] = useState<string | undefined>(undefined)
  const initialContext = { activeItem, setActiveItem }

  return (
    <AccordionListContext.Provider value={initialContext}>
      <div className={variants({ admin: env.admin })}>
        <InnerBlocks allowedBlocks={["content/accordion-list-item"]} template={[["content/accordion-list-item", null]]} orientation="vertical" />
      </div>
    </AccordionListContext.Provider>
  )
})
